import { AddPaymentDocument } from './ui';

export { AddPaymentDocument };
